import React, { useCallback } from 'react';
import AppLayout from '../../component/appLayout';
import { Container, Content, HeaderLeft, Heading, Title } from './styles';
import Button from '../../component/button';
import ViewsTable from '../../component/viewsTable';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { rootStore } from '../../mobx/rootStore';
import { BUTTON_TYPE, EMPTY_STATE_SIZE } from '../../global/constants';
import { useMobileDevice } from '../../global/useMobile';
import ResponsiveHeader from '../../component/responsiveHeader';
import BottomSubNavigation from '../../component/bottomNavigation/subNavigation';
import EmptyStateV2 from '../../component/emptyState';
import BottomNavigationItem from '../../component/bottomNavigation/subNavigation/bottomNavigationItem';
import { ROUTES } from '../../routes/urls';

const Views = observer(() => {
  const history = useHistory();

  //Mobx store variables
  const { viewStore } = rootStore;
  const { views } = viewStore;
  //other variables
  const isMobile = useMobileDevice();

  const onClickNewView = useCallback(() => {
    history.push(ROUTES.VIEWS_NEW);
  }, [history]);

  return (
    <>
      <AppLayout>
        <Container className='desktop-content'>
          {isMobile ? (
            <ResponsiveHeader title='Views' />
          ) : (
            <Content>
              <HeaderLeft>
                <Heading>
                  <Title>Views</Title>
                </Heading>
              </HeaderLeft>
              {views.length > 0 && (
                <Button
                  title='New view'
                  variant={BUTTON_TYPE.PRIMARY}
                  onClick={onClickNewView}
                  iconName='plus-icon'
                  iconPosition='start'
                  size='small'
                />
              )}
            </Content>
          )}
          {views.length > 0 ? (
            <ViewsTable />
          ) : (
            <EmptyStateV2
              size={EMPTY_STATE_SIZE.MEDIUM}
              imageUrl={'views_empty'}
              title={`No views created yet`}
              description='Create views using filters for the tasks.'
              onClick={onClickNewView}
              buttonTitle='New view'
              isAlignedCenter={true}
            />
          )}
        </Container>
      </AppLayout>
      <BottomSubNavigation
        backNavigationPath={ROUTES.HOME}
        rightElement={<BottomNavigationItem iconName='plus-icon' onClick={onClickNewView} />}
      />
    </>
  );
});

export default Views;
